import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserCheckFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.58697 11.6665H5.83317C3.53198 11.6665 1.6665 13.532 1.6665 15.8332C1.6665 17.2139 2.78579 18.3332 4.1665 18.3332H14.1665C15.5472 18.3332 16.6665 17.2139 16.6665 15.8332C16.6665 15.5659 16.6413 15.3046 16.5933 15.0513C16.2958 15.4291 16.0264 15.8277 15.7877 16.245C15.4011 16.921 14.7215 17.3783 13.9496 17.4818C13.1777 17.5852 12.4017 17.323 11.8507 16.7726L9.89968 14.8237C9.04083 13.9658 8.93644 12.6385 9.58697 11.6665Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.99984 5.83317C4.99984 3.53198 6.86532 1.6665 9.1665 1.6665C11.4677 1.6665 13.3332 3.53198 13.3332 5.83317C13.3332 8.13436 11.4677 9.99984 9.1665 9.99984C6.86532 9.99984 4.99984 8.13436 4.99984 5.83317Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.9699 11.5213C18.3499 11.2617 18.4475 10.7431 18.1879 10.3631C17.9283 9.98308 17.4098 9.88546 17.0298 10.1451C15.6383 11.0956 14.4246 12.2854 13.468 13.6767L12.2554 12.4654C11.9298 12.1402 11.4022 12.1405 11.0769 12.4661C10.7517 12.7917 10.752 13.3193 11.0776 13.6446L13.0286 15.5935C13.2122 15.777 13.4709 15.8644 13.7282 15.8299C13.9855 15.7954 14.212 15.643 14.3409 15.4176C15.2316 13.86 16.4792 12.5396 17.9699 11.5213Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgUserCheckFilled);
export default ForwardRef;
